// extracted by mini-css-extract-plugin
export default {"component":"rqi1jr","headline":"_wRcw8","wrapper":"Fgjxp4","image":"liLovi"};